import React, { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import style from './index.module.less'
import * as yup from "yup"
import { footer_email_list } from '@/utils/regions.js'
import getCountry from '@/utils/getCountry.js'
import { GoSubmit, LoadingSubmit } from '@/images/index'
import { useGTM } from '@/hooks/useGTM.js'

//邮箱验证
const emailSchema = yup
    .string()
    .email()
    .required()
const Email = ({gtmEventModule, gtmEventName, gtmBtnType}) => {
    const intl = useIntl()
    const [status, setStatus] = React.useState('edit')
    const [buttondis, setButtondis] = React.useState(false)
    const [validate, setValidate] = useState(true)
    const [inputValue, setInputValue] = useState('')
    const inputBox = useRef()
    const region = getCountry()
    const GTM = useGTM

    const inputChange = (e) => {
        setInputValue(e.target.value)
    }

    useEffect(() => {

        if (status == 'sending') {
            setButtondis(true)
        }
        if (status == 'success') {
            setButtondis(true)

        }
    }, [status])
    const submit = async () => {

        if (buttondis) {
            return
        }
        setStatus('sending')
        const isValid = await emailSchema.isValid(inputValue)
        if (!isValid) {
            setValidate(false)
            setStatus('edit')
            setButtondis(false)
            return
        }
        
        if (gtmEventName) {
            GTM(gtmEventName, gtmBtnType, '', gtmEventModule)
        }
        setValidate(true)

        let formdata = new FormData();
        formdata.append("email", inputValue);

        let requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow',
            Headers: {
                'Access-Control-Allow-Origin': "*"
            },
            mode: "no-cors"
        };

        fetch(footer_email_list[region], requestOptions)
            .then(response => {
                response.text(); setStatus('success')

            })
            .then(result => console.log(result))
            .catch(error => console.log('error', error));
    }


    return (
        <div className={style.formBox} >
            <div className={style.formBoxTitle} dangerouslySetInnerHTML={{ __html: `${intl.formatMessage({ id: "footerpage.text1.mobile", defaultMessage: "Keep in touch" })}` }} ></div>
            <div className={style.formBoxInput}
                ref={inputBox}
            >
                <input
                    placeholder={intl.formatMessage({ id: "email_text" })}
                    onChange={(e) => inputChange(e)}
                    value={inputValue}
                />
                
                <button onClick={submit} style={{ cursor: status == 'success' ? 'auto' : "pointer" }}>   
                    {(status == 'edit' || status == 'success')  && <GoSubmit 
                        className={style.submitIcon}
                        style={{
                            opacity: status == 'success' || inputValue ? 1 : 0.6
                        }}
                    />
                    }
                    {status == 'sending' && <LoadingSubmit 
                        className={style.submitIcon}
                    />
                    }
                </button>
                

                {!validate && inputValue && <div className={style.error}>{intl.formatMessage({ id: "form.requireEmail" })}</div>}
            </div>

        </div>
    )
}

export default Email